<template>
  <ReviewsView
    v-if="reviews && reviews.length > 0"
    :reviews
    :subtitle
    :title
    :tracking
  />

  <RevSkeleton
    v-else-if="pending"
    height="560px"
    shape="rectangle"
    width="100%"
  />
</template>

<script lang="ts" setup>
import { useAsyncData } from '#imports'

import type { ReviewsProps } from '@backmarket/http-api/src/api-specs-content/models/reviews'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { RevSkeleton } from '@ds/components/Skeleton'

import type { ContentBlockProps } from '../../models/content-block'

import { mapToReviews } from './Reviews.utils'
import ReviewsView from './components/ReviewsView.vue'

const props = defineProps<ReviewsProps & ContentBlockProps>()

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error'])

const $httpFetch = useHttpFetch()
const { data: reviews, pending } = useAsyncData(
  getAsyncDataKey('cms-reviews', { public_id__in: props.reviews_ids }),
  () => {
    return $httpFetch('/reviews/v1/products/reviews', {
      query: { public_id__in: props.reviews_ids },
    })
  },
  {
    transform: (res) => mapToReviews(res.results),
    // this prevents request duplication when using Lazy Hydration on the component
    getCachedData: (key, nuxtApp) => {
      return nuxtApp.payload.data[key]
    },
  },
)
</script>
